import React, { Component } from 'react'
import { withRouter } from 'react-router'
import styled from 'styled-components'
import { Container, Flex } from './common'
import { color } from '../globalStyles'
import Logo from './Logo'
import NavLink from './NavLink'

const MenuButton = styled.a`
  position: absolute;
  padding: 0.5rem;
  right: 0;
  top: 1.25rem;
  width: 3rem;
  height: 3rem;
  cursor: pointer;
  border: none;
  border-radius: 3px;
  background: ${color.lightGrey};
  display: flex;
  align-items: center;
  justify-content: center;

  &:focus {
    outline: none;
  }

  img {
    width: 100%;
    height: auto;
    display: block;
    opacity: 0.5;
  }
`
const Nav = styled.nav`
  background: white;
  position: -webkit-sticky;
  position: sticky;
  z-index: 1;
  top: 0;

  ${Flex} {
    flex-direction: column;
    padding-bottom: 1rem;
    border-bottom: 1px solid ${color.lightGrey};
  }

  .NavLink {
    display: ${props => props.open ? 'block' : 'none'};
  }

  @media (min-width: 777px) {
    ${Flex} {
      flex-direction: row;
      padding-bottom: 0;
    }

    ${MenuButton} {
      display: none;
    }

    .NavLink {
      display: block;
    }
  }
`
const StyledLogo = styled(Logo)`
  margin-right: auto;
`

class NavComponent extends Component {
  constructor (props) {
    super(props)
    this.state = {
      menuOpen: false
    }
    this.toggleMenu = this.toggleMenu.bind(this)
  }

  componentDidUpdate (prevProps) {
    if (this.props.location !== prevProps.location) {
      this.setState({ menuOpen: false })
    }
  }

  toggleMenu (e) {
    e.preventDefault()
    this.setState({ menuOpen: !this.state.menuOpen })
  }

  render () {
    const { menuItems } = this.props
    return (
      <Nav open={this.state.menuOpen}>
        <Container relative>
          <Flex alignCenter>
            <StyledLogo />
            {menuItems.map((route, i) => (
              <NavLink className='NavLink' key={i} {...route} />
            ))}
            <MenuButton onClick={this.toggleMenu}>
              <img src={`${process.env.PUBLIC_URL}/bars.svg`} alt='Menu Button' />
            </MenuButton>
          </Flex>
        </Container>
      </Nav>
    )
  }
}

export default withRouter(NavComponent)



// WEBPACK FOOTER //
// ./src/components/Nav.js